<template>
    <v-card class="mx-auto" max-width="600">
      <v-card-title>
        グループメンバー覧
        <v-spacer/>
        <v-text-field v-model="search" append-icon="mdi-magnify" label="Search" single-line hide-details></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="myGroupMembers" :search="search">

      <template v-slot:[`item.userPhotoURL`]="{ item }">
       <v-list>
         <v-list-item-avatar><v-img :src="item.userPhotoURL"></v-img></v-list-item-avatar>
        </v-list>
      </template>          
      <template v-slot:[`item.userName`]="{ item }">
        
        <v-list-item  v-if="loginUserId == item.userId">あなたです</v-list-item>
        <v-list-item v-else>
          <v-list-item-content @click="toUserPage(item.userId)" :style="{ cursor: 'pointer',color: 'blue'}" >{{item.userName}}</v-list-item-content>
        </v-list-item>
        
      </template>
      </v-data-table>
    </v-card>
</template>
<script>
  import { mapActions, mapGetters} from "vuex"
  export default {

    components: {

    },
    computed: {
      ...mapGetters(['loginUserId','myGroupMembers'])
    },
    data () {
      return {
        search: '',
        headers: [
          {text: '', align: 'center', value: 'userPhotoURL'},
          { text: '', value: 'userName' },
        ],
      }
    },
    methods: {
      toUserPage(userId) {
        this.$router.push({ name: "User", params: { "user_id": userId } });
    },
        ...mapActions(['job/fetchGroupJobs'])
    }
  }
</script>
